<template>
  <div>
    <!-- background blur when modal popup -->
    <div class="blur-bg"></div>
    <!-- Modal -->
    <div class="modal fade" id="meterModal" tabindex="-1" aria-labelledby="meterModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h3>編輯電表</h3>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>編輯電表名稱</label>
              <input class="form-control" type="text" v-model.lazy="alias"
                :placeholder="edit_meter_data.mac_alias ?? '輸入電表名稱'">
            </div>
            <div class="form-group">
              <p>上傳照片</p>
              <label for="file-upload" class="custom-file-upload">
                <i class="fa fa-cloud-upload"></i>
              </label>
              <input id="file-upload" type="file" @change="handleFileUpload" class="d-none" />
              <span id="file-name-display"></span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" @click="editMeter(edit_meter_data.bx_mac)">送出</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      alias: '',
      edit_meter_data: '',
      selected_file: null, // 新增這一行
    }
  },
  mounted() {
    if (this.meter.id) {
      this.edit_meter_data = this.meter;
    }
  },
  computed: {
    meter() {
      return this.$store.getters.selectedMeter;
    },
    selectedRegion() {
      return this.$store.getters.selectedRegion;
    },
  },
  watch: {
    selectedRegion() {
      this.edit_meter_data = this.selectedRegion.meters[0];
    },
    meter() {
      this.edit_meter_data = this.meter;
    },
    deep: true,
  },
  methods: {
    async editMeter(bx_mac) {
      this.closeModal();
      const formData = new FormData();
      formData.append('bx_mac', bx_mac);
      if (this.alias) {
        formData.append('mac_alias', this.alias);
      }
      if (this.selected_file) {
        formData.append('image', this.selected_file); // 將圖片檔案加入 FormData
      }
      console.log('--edit-meter--', formData);
      await axios.post(base_url + "/api/bx/mac/" + this.selectedRegion.id + '?_method=PATCH', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((response) => {
        this.$store.dispatch('setUserRegions');
        this.alias = '';
        this.selected_file = null;
      }).catch(function (error) {
        console.error(error.toJSON());
      });
      this.$store.commit('setShowSpinner', false);
    },
    closeModal() {
      const modal = this.$el.querySelector('#meterModal');
      const blur_bg = this.$el.querySelector('.blur-bg');
      modal.style.display = 'none';
      modal.classList.remove('show');
      blur_bg.style.display = 'none';
    },
    // TODO: upload image
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        // 更新頁面上的元素以顯示檔案名稱
        this.$el.querySelector('#file-name-display').innerText = `選擇的檔案：${file.name}`;
        this.selected_file = file; // 儲存選擇的檔案
      }
      console.log(file.name);
    },
  },
}
</script>

<style scoped>
.blur-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
  display: none;
}

.custom-file-upload {
  color: var(--bx-green);
  font-size: 1.2rem;
  display: inline-block;
  padding: 0 6px;
  cursor: pointer;
  background-color: white;
  border: 1px solid var(--bx-green);
  border-radius: 4px;
  margin-right: 5px;
}

.custom-file-upload:hover {
  background-color: var(--bx-unselected-btn);
}
</style>
